













































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import RepairContentList from "@/components/repair-content/repairContentList.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import VueUploadComponent from "vue-upload-component";
import fileApi from "@/api/fileApi";
import _ from "lodash";
import { ContractMoveOutCheckList } from "@/model/contractMoveOut";
import QPolygonFloor, { drawMode } from "@/common/qPolygonFloor.vue";
import Property from "@/model/property";
import { CheckPoint } from "@/store/modules/confirmContract";
// eslint-disable-next-line @typescript-eslint/no-var-requires
var noimage = require("@/assets/images/muuq-base/noimage.png");
// eslint-disable-next-line @typescript-eslint/no-var-requires
var starImage = require("@/assets/images/iconmonstr-star-6-24.png");
@Component({
  name: "CheckPointPopup",
  components: {
    RepairContentList,
    QTableHeader,
    VueUploadComponent,
    QPolygonFloor,
  },
})
export default class CheckPointPopup extends Vue {
  public files = [];
  public checkPoint: ContractMoveOutCheckList = null;
  public property: Property;
  public imageSelected = 0;
  public isShow = false;
  public imageField = "repair_image_id";
  public mode = "Edit";
  public imgStart;
  public fromCustomerCheckList: CheckPoint;
  public step: "CheckList" | "Correct" = "CheckList";

  mounted() {
    this.imgStart = document.createElement("img");
    this.imgStart.src = starImage;
  }
  public remove() {
    this.$modal.showDelete({
      text: this.$t("delete"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        this.$emit("remove", this.checkPoint);
        this.isShow = false;
      },
    });
  }
  public inputFile(newFile) {
    this.handleFileUpload(newFile.map((item) => item.file));
    this.files = [];
  }

  public inputFilter(newFile, oldFile, prevent) {
    if (newFile && !oldFile && !/\.(jpeg|jpg|png)$/i.test(newFile.name)) {
      return prevent();
    }
  }

  public async handleFileUpload(files) {
    if (files.length === 0) {
      return;
    }
    const requestUploads = [];
    for (const file of files) {
      let formData = new FormData();
      formData.append("image", file);
      formData.append("image_type", "RepairContent");
      requestUploads.push(fileApi.uploadImage(formData));
    }
    const results = await Promise.all(requestUploads);

    for (const result of results) {
      if (result.meta.status === 200) {
        this.checkPoint[this.imageField].push(result.data);
      }
    }
  }

  public onChangeFile(event) {
    this.handleFileUpload(event.target.files);
  }

  public removeImage(image) {
    const index = this.checkPoint.repair_image_id.findIndex(
      (item) => item.id === image.id
    );
    if (index > -1) {
      this.checkPoint.repair_image_id.splice(index, 1);
    }
  }

  public mainImage() {
    if (
      this.checkPoint.repair_image_id.length > 0 &&
      this.checkPoint.repair_image_id[this.imageSelected]
    ) {
      return this.checkPoint[this.imageField][this.imageSelected].url;
    }
    return noimage;
  }

  public show(
    checkPoint: ContractMoveOutCheckList,
    property: Property,
    mode: "Detail" | "Edit" | "Resident" = "Edit",
    fromCustomerCheckList = null,
    step: "CheckList" | "Correct" = "CheckList"
  ) {
    this.step = step;
    this.mode = mode;
    this.imageSelected = 0;
    this.property = property;
    this.checkPoint = new ContractMoveOutCheckList(_.cloneDeep(checkPoint));
    this.isShow = true;
    this.fromCustomerCheckList = fromCustomerCheckList;
    let iconCheckPoint;
    if (mode === "Edit" || mode === "Detail") {
      iconCheckPoint = {
        text: checkPoint.order + "",
        type: "Circle",
        id: checkPoint.id || checkPoint._id,
      };
    } else {
      iconCheckPoint = this.imgStart;
    }
    this.$nextTick(() => {
      const { clientWidth } = this.$refs.CheckPointArea as Element;
      (this.$refs.qFloor as QPolygonFloor).loadObject(
        this.property.floor_plan.svg_object,
        this.property.floor_plan.areas,
        drawMode.repair,
        {
          width: clientWidth,
          height: clientWidth,
        },
        iconCheckPoint
      );
      if (this.mode === "Resident" || this.mode === "Detail") {
        (this.$refs.qFloor as QPolygonFloor).setConfig({
          moving: false,
          selectable: false,
        });
      }
      if (checkPoint.floor_area) {
        checkPoint.is_show_checkpoint &&
          (this.$refs.qFloor as QPolygonFloor).selectAreaRepair(
            checkPoint.floor_area.group_id,
            checkPoint.svg_position
          );
      }
    });
  }

  public submit() {
    this.isShow = false;
    this.checkPoint.svg_position = (
      this.$refs.qFloor as QPolygonFloor
    ).getRepaiIconPosition();
    // emit event;
    this.$emit("change", this.checkPoint);
  }

  public changeArea(groupId) {
    if (groupId) {
      const area = this.property.floor_plan.areas.find(
        (item) => item.group_id === groupId
      );
      if (area) {
        this.checkPoint.floor_area = area;
        this.checkPoint.floor_area_id = area.id;
      }
      this.checkPoint.is_show_checkpoint = true;
    } else {
      this.checkPoint.floor_area = null;
      this.checkPoint.floor_area_id = null;
    }
  }

  public removeCheckPoint() {
    (this.$refs.qFloor as QPolygonFloor).selectAreaRepair(null);
    this.checkPoint.is_show_checkpoint = false;
  }

  public onMovedCheckPoint(objectFabric) {
    this.checkPoint.svg_position = objectFabric;
  }
  public isNotFromCustomer(id) {
    if (this.fromCustomerCheckList) {
      return (
        this.fromCustomerCheckList.images.findIndex(
          (item) => item.id === id
        ) === -1
      );
    } else {
      return true;
    }
  }

  public canDeleteCheckList(checkList: ContractMoveOutCheckList) {
    return !checkList.from_customer_check_list_id || this.step === "Correct";
  }

  @Watch('isShow')
  public checkDisplayModal() {
    if (this.isShow) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }
}
